import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { useSelector } from "react-redux";

let webApiUrl = `${process.env.REACT_APP_BASE_URL}info/`;
let tokenStr = process.env.REACT_APP_API_TOKEN;

export const fetchInfo = createAsyncThunk("deviceInformation/fetchInfo", () => {
  return axios
    .get(webApiUrl, { headers: { Authorization: `Token ${tokenStr}` } })
    .then((response) => response.data.results);
});

const informationSlice = createSlice({
  name: "information",
  initialState: {
    informationLoading: localStorage.getItem("refreshToken") || true,
    informationData: localStorage.getItem("refreshToken") || [],
    informationError: localStorage.getItem("refreshToken") || null,
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchInfo.pending,
      (state) => {
        state.informationLoading = true;
        state.informationData = [];
        state.informationError = null;
      },
      builder.addCase(
        fetchInfo.fulfilled,
        (state, action) => {
          state.informationData = action.payload;
          state.informationLoading = false;
          state.informationError = null;
        },
        builder.addCase(fetchInfo.rejected, (state, action) => {
          state.informationLoading = false;
          state.informationData = [];
          state.informationError = action.error.message;
        })
      )
    );
  },
});
export default informationSlice.reducer;
